var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { getObservableT } from "../Infra/i18next";
import { autorun, computed, observable } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
const t = getObservableT("patients");
export class PatientSwitchOrganizationViewModel {
    constructor(container) {
        this.healthcareOrganizationToSwitchTo = NOT_LOADED;
        this.organizationsManager = container.organizationsManager;
        this.loginUIManager = container.loginUIManager;
        autorun(async () => {
            this.healthcareOrganizationToSwitchTo = await this.loadOrganization();
        });
    }
    get toContinueText() {
        const org = this.healthcareOrganizationToSwitchTo === NOT_LOADED ? null : this.healthcareOrganizationToSwitchTo;
        if (!org) {
            return "";
        }
        return t("To continue to {{ healthSystem }} on HealthEx and access", {
            healthSystem: org.name,
        });
    }
    async loadOrganization() {
        var _a;
        const orgId = (_a = this.loginUIManager.pendingUserChoiceToSwitchOrgLink) === null || _a === void 0 ? void 0 : _a.organizationId;
        if (!orgId)
            return null;
        return await this.organizationsManager.loadOrganizationPublicProfile(orgId);
    }
    logout() {
        this.loginUIManager.completeOrganizationSwitch(true);
    }
    stayLoggedIn() {
        this.loginUIManager.completeOrganizationSwitch(false);
    }
}
__decorate([
    observable
], PatientSwitchOrganizationViewModel.prototype, "healthcareOrganizationToSwitchTo", void 0);
__decorate([
    computed
], PatientSwitchOrganizationViewModel.prototype, "toContinueText", null);
